module.exports = __webpack_public_path__ + "img/visual-card-none.71a866d6.svg";